// PopupVideo.jsx
import React, { useEffect, useState } from 'react';
import './../css/PopupVideo.css';
import DemoVideo from './../assets/images/Demo.mp4';

const PopupVideo = () => {
    const [showPopup, setShowPopup] = useState(false);
  
    useEffect(() => {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 4000); // 2000 millisecondes = 2 secondes
  
      return () => clearTimeout(timer);
    }, []);
  
    const closePopup = () => {
      setShowPopup(false);
    };
  
    return (
      <div className="popup-container">
        {showPopup && (
          <div className="popup">
            <div className="popup-content">
              <span className="close" onClick={closePopup}>&times;</span>
              <h4>Demo</h4> 
              <video width="200" height="150" controls>
                <source src={DemoVideo} type="video/mp4" />
                Votre navigateur ne supporte pas la balise vidéo.
              </video>
            </div>
          </div>
        )}
      </div>
    );
  };
  
  export default PopupVideo;